jQuery(document).ready(function(){

    // On vérifie que le Select est bien présent
    if(jQuery("#contactform_choice").length){

      // Si il y a un paramètre au sein de l'ur et que celui c'est est égale à légi-entite, on retrouve le formulaire via un champ caché présent dans le forumlaire Contact Form 7 et on récupère l'id du formulaire pour imiter un click sur l'option choisi.
      const url = window.location.href;
      const newURL = new URL(url);

      if(newURL.searchParams.has('legi-entite')){
        const paramValue = newURL.searchParams.get('legi-entite');
        const selectedElement = jQuery(".wpcf7-hidden[value='"+paramValue+"']");

        if(jQuery(selectedElement).val() == paramValue){
          var parentContactID = jQuery(selectedElement).closest('.wpcf7').attr('data-wpcf7-id');
          
          // On simule le click 
          jQuery('option[attr-wpcf-id="'+parentContactID+'"')
            .prop('selected',true)
            .trigger('change');

            onChange();
        }
      }
  
      // Quand un changement de donner est effectué sur le select on récupère son attribut.
      jQuery("#contactform_choice").on('change',function(){
        onChange();
      });

    }

});

function onChange(){

  let contact_form_selected_id = jQuery('#contactform_choice').find(':checked').attr('attr-wpcf-id');
  let contact_form_element = jQuery('div[data-wpcf7-id="'+contact_form_selected_id+'"]');

  // On vérifie si le formulaire n'est pas déjà chargé, sinon on l'appelle via Ajax
  if( jQuery(contact_form_element).length ){

    // On masque les formulaires et on affiche le formulaire sélectionné
    jQuery('.wpcf7.visible').fadeOut(200, function(){});
    jQuery(contact_form_element).closest('.wpcf7').fadeIn();
    jQuery(contact_form_element).closest('.wpcf7').addClass('visible');

  }
}